import { Layout } from 'antd';
import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { BREAKPOINTS, ROUTES } from '../common/constants';
import FooterContent from '../components/FooterContent';
import MobileLogoComponent from '../components/MobileLogoComponent';
import useRouter from '../hooks/useRouter';
import AppHeader from './components/header/AppHeader';
import UserProfile from './components/header/UserProfile';

const { Content, Footer } = Layout;
const App = () => {
  const [isDesktop, setDesktop] = useState(
    // eslint-disable-next-line no-undef
    window.innerWidth > BREAKPOINTS.tablet,
  );
  const [isActive, setActive] = useState(false);
  const { navigate } = useRouter();

  const handleOverlay = () => {
    setActive(!isActive);
  };

  useEffect(() => {
    const updateMedia = () => {
      setDesktop(window.innerWidth > BREAKPOINTS.tablet);
    };
    // eslint-disable-next-line no-undef
    window.addEventListener('resize', updateMedia);
    // eslint-disable-next-line no-undef
    return () => window.removeEventListener('resize', updateMedia);
  });

  return (
    <Layout hasSider>
      {!isDesktop && (
        <span
          className={isActive ? 'active overlay-responsive' : 'overlay-disable'}
          onClick={handleOverlay}
        />
      )}

      <Layout className="site-layout">
        <AppHeader>
          <div className="header-wrapper">
            <div className="header-left">
              <div
                className="responsive-logo text-center pointer"
                onClick={() => navigate(ROUTES.MAIN)}
              >
                <MobileLogoComponent />
              </div>
              <div>
                <div id="breadcrumb" />
              </div>
            </div>
            <div className="header-right">
              <UserProfile />
            </div>
          </div>
        </AppHeader>
        <Content className="wrapper">
          <Outlet />
        </Content>
        <Footer>
          <FooterContent />
        </Footer>
      </Layout>
    </Layout>
  );
};

export default App;
